<script setup lang="ts">

import { useBaseDataStore } from '@/user/store/baseDataStore.ts';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { storeToRefs } from 'pinia';
import WhatsAppClickToChat from '@/application/components/WhatsAppClickToChat.vue';
import { usePhoneNumber } from '@/application/composables/usePhoneNumber.ts';

const { duzen } = useBaseDataStore();
const {
  isAuthenticated,
  isBroker,
  firmenname,
  makleremail,
  maklertelefon,
  maklername,
  maklerIsAgency,
  kundeVorname,
  kundeNachname,
} = storeToRefs(useBaseDataStore());

const { mobilNumber } = usePhoneNumber();
</script>

<template>
  <div class="flex flex-col justify-between bg-gray-50 rounded-2xl p-3 mb-auto">
    <div
      v-if="isBroker"
      class="text-center mb-2.5 text-muted bg-light p-1.5 mt-4"
    >
      Sie beraten gerade {{ kundeVorname }} {{ kundeNachname }}
    </div>
    <div
      v-if="isAuthenticated"
      class="flex flex-col gap-5 text-center"
    >
      <div class="flex flex-col text-start text-gray-900">
        <span class="font-medium text-xl">{{ duzen('Du hast', 'Sie haben') }} Fragen?</span>
        <span class="font-normal text-lg">{{ duzen('Kontaktiere', 'Kontaktieren Sie') }} {{ maklerIsAgency ? 'uns' : 'mich' }} gerne!</span>
      </div>
      <div class="text-gray-800 flex flex-col gap-5 items-start justify-center">
        <div class="flex flex-col items-start text-start text-sm">
          <span v-if="maklername && maklername !== firmenname">{{ maklername }}</span>
          <span v-if="firmenname">{{ firmenname }}</span>
        </div>

        <div class="font-medium flex flex-col gap-2 items-start">
          <WhatsAppClickToChat v-if="!!mobilNumber" :mobil-number="mobilNumber" />

          <a v-if="maklertelefon" :href="`tel:${maklertelefon}`">
            <div class="flex flex-row items-center gap-2 text-blue-700 bg-blue-100/50 hover:bg-blue-100 hover:text-blue-800 rounded-full py-1 pl-1 pr-3">
              <FaIcon
                name="phone"
                variant="regular"
                class="bg-white p-2 rounded-full text-gray-700"
              />
              <span>{{ maklertelefon }}</span>
            </div>
          </a>

          <a v-if="makleremail" :href="`mailto:${makleremail}`">
            <div class="flex flex-row items-center gap-2 text-blue-700 bg-blue-100/50 hover:bg-blue-100 hover:text-blue-800 rounded-full py-1 pl-1 pr-3">
              <FaIcon
                name="envelope"
                variant="regular"
                class="bg-white p-2 rounded-full text-gray-700"
              />
              <span>{{ makleremail }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
